import { USER_ROLES } from '../../../utils/factories/userRoles';

export default function getRoleLabelText(role) {
  return USER_ROLES.find((r) => r.value === role).label;
}
